<template>
    <div class="form-group">
        <label class="form-label" v-if="!!label" for="">{{ label }} <span v-if="!!required" class="field-required-mark">*</span></label>
        <input 
            v-bind="$attrs" 
            :type="type" 
            class="form-control" 
            :class="inputClasses"
            :disabled="disabled" 
            @input="updateVal($event.target.value)" :id="id" 
            :value="value" 
            @change="$emit('change', $event)" 
            :placeholder="placeholder"
            @keyup.enter="$emit('keyup.enter', $event)"
            @blur="$emit('blur', $event)"
        >
        <small class="text-muted" v-if="!!description">{{description}}</small>
        <span class="field-error" v-if="!!hasError">{{ errorMessage }}</span>
    </div>
</template>
<script>
    export default {
        inheritAttrs: false,
        props: {
            value: {
                type: String
            },
            label: {
                type: String,
                default: ''
            },
            hasError: {
                type: Boolean,
                default: false
            },
            errorMessage: {
                type: String,
                default: ''
            },
            description: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'text'
            },
            id: {
                type: String,
                default: () => {
                    return 'input-' + (parseInt(Math.random()*100000000));
                }
            },
            placeholder: {
                type: String
            },
            required: {
                default: ''
            },
            disabled: {
                default: false
            },
            autofocus: {
                type: Boolean,
                default: false
            },
            inputClasses: {
                type: Object,
                default: () => {}
            }
        },
        methods: {
            updateVal(val){
                this.$emit('input', val);
            },
            focus() {
                $(`#${this.id}`).focus();
            }
        },
        mounted(){
            if(!!this.autofocus){
                $(`#${this.id}`).focus();
            }
        }
    }
</script>